<div class="wrapper">
  <ix-widget-datapoint
    [size]="size()"
    [label]="settings().widgetTitle | translate"
    [text]="settings().widgetText | translate"
    [subText]="settings().widgetSubText | translate"
  ></ix-widget-datapoint>
</div>
